export default "__VITE_ASSET__4237fc77__"